import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

// Handles the return from Emergent Google Auth: reads #session_id, exchanges it
// for our JWT on the backend, then redirects home.
const AuthCallback = () => {
  const { loginWithSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    (async () => {
      try {
        if (sessionId) await loginWithSession(sessionId);
      } catch (e) {
        // fall through to home; user can retry
      } finally {
        window.history.replaceState({}, document.title, "/");
        navigate("/", { replace: true });
      }
    })();
  }, [loginWithSession, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#faf8f4] font-sans text-neutral-500">
      <Loader2 className="mr-2 h-5 w-5 animate-spin" /> signing you in…
    </div>
  );
};

export default AuthCallback;
